import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const contents = ['Explicación clara de las 4 fases del ciclo', 'Qué sucede en tu cuerpo y mente en cada una', 'Qué hacer y qué evitar en cada fase', 'Una rutina simple y adaptable semana a semana', 'Manejo práctico de antojos y emociones', 'Acciones concretas para cada semana'];
export function ProductContentSection() {
  return <section className="w-full bg-bg-alt py-16 md:py-24 px-4" data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-12" data-id="element-103">
          ¿Qué incluye la Guía Ciclo Consciente?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex justify-center" data-id="element-105">
            <img src="https://cdn.magicpatterns.com/uploads/iFFFD5wHaayt97puUmBzLx/ChatGPT_Image_18_abr_2026,_11_01_55.png" alt="Contenido de la guía" className="w-full max-w-sm drop-shadow-xl" data-id="element-106" />
          </motion.div>

          <div className="space-y-4" data-id="element-107">
            {contents.map((content, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-4 items-start" data-id="element-108">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center mt-1" data-id="element-109">
                  <Check className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-110" />
                </div>
                <p className="text-lg text-text-primary" data-id="element-111">{content}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}